export default __webpack_public_path__ + "static/media/pos-z.95b0e12a.jpg";